export default __webpack_public_path__ + "static/media/accommodations2_668.1a4049ae.webp";